const SingleEvent = {
	init: function() {
	}
}

export default SingleEvent;